import { render, staticRenderFns } from "./Arquivos.vue?vue&type=template&id=4ed09a87&scoped=true&"
import script from "./Arquivos.vue?vue&type=script&lang=js&"
export * from "./Arquivos.vue?vue&type=script&lang=js&"
import style0 from "./Arquivos.vue?vue&type=style&index=0&id=4ed09a87&scoped=true&lang=css&"
import style1 from "./Arquivos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed09a87",
  null
  
)

export default component.exports